<div class="w-full flex flex-col p-5">
    <h2 class="font-bold">ورود یا عضویت</h2>

    <div class="flex flex-col relative gap-2 my-5">
        <label for="small-test-input" class="text-muted"> شماره موبایل </label>
        <input ihoInput size="md" 
        class="{{disabledBtn ? '!border-red-300': 'border-2' }} w-full"
        type="number" [ngModel]="phoneNumber"
        (ngModelChange)="phoneNumber = persianToEnglishRegex( $event)"
        (keyup.enter)="handledRegister()"
        (input)="handledRegex($event)" type="tel" inputmode="numeric"
        id="small-test-input" 
        placeholder=" مثال: 09123456798">
        <p class="text-red-300 text-xs mt-1" *ngIf="disabledBtn && phoneNumber">فیلد شماره موبایل اشتباه است</p>
        <p class="text-red-300 text-xs mt-1" *ngIf="!phoneNumber && disabledBtn">فیلد شماره موبایل خالی است</p>
    </div>
    <p class="w-full my-3 text-sm">
        با ادامه، شما <a href="/persian/policy/" target="_blank" class="text-blue-500">شرایط و ضوابط</a> ایران هتل را مطالعه کرده و با آن
        موافقت می کنید.
    </p>

    <button mat-raised-button color="primary"
        class="!font-bold !text-base !h-11"
        [disabled]="phoneNumber.length !== 11 || showLoading"
        (click)="handledRegister()"> 
     
        <div class="typing-animation" *ngIf="showLoading">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <span  *ngIf="!showLoading">تایید و ادامه</span>    
    </button>
   

</div>